// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__zafaf","label":"styles_label__rQ0l0","caption":"styles_caption__Wi18K","description":"styles_description___gdO6","content":"styles_content__0tKdO"};